import { Tooltip } from '@mantine/core';
import React, { useEffect, useMemo, useRef, useState } from 'react';

export interface Props {
  width?: number;
  children?: string;
  className?: string;
}

export const EllipsisTooltip = (props: Props) => {
  const { width = 100, children, className = '' } = props;

  const textRef = useRef<HTMLSpanElement>(null);
  const [isTruncated, setIsTruncated] = useState(false);

  useEffect(() => {
    const el = textRef.current;
    if (el) {
      // Проверяем, не выходит ли содержимое за границы видимой области
      setIsTruncated(el.scrollWidth > el.clientWidth);
    }
  }, [children, width]);

  const styles = useMemo(
    () => ({
      display: 'inline-block',
      width: 'fit-content',
      maxWidth: width,
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis'
    }),
    [width]
  );

  return (
    <Tooltip zIndex={1300} disabled={!isTruncated} label={children} color="gray">
      <span ref={textRef} className={className} style={styles}>
        {children}
      </span>
    </Tooltip>
  );
};
